export default __webpack_public_path__ + "static/media/img_regua_vertical_nova.11fb06e2.png";